<template>
  <div class="kb-icon-button" :class="buttonClasses">
    <kb-base-icon :icon="icon"></kb-base-icon>
  </div>
</template>

<script>

export default {
  name: 'kb-icon-button',
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'primary-light'
    },
    size: {
      type: String,
      required: false,
      default: 'normal'
    }
  },
  computed: {
    buttonClasses: function() {
      return `kb-icon-button--${this.color} kb-icon-button--${this.size}`;
    }
  },
  methods: {}
}
</script>

<style lang="scss">
  @import '../../../scss/_colors';
  @import '../../../scss/_variables';

  .kb-icon-button {
    display: inline-block;
    border-radius: 100px;
    box-sizing: border-box;

    &--small {
      font-size: $fontSizeXs;
      padding: $spacingXs;
      height: 24px;
      width: 24px;
    }

    &--normal {
      padding: $spacingXs;
      height: 27px;
      width: 27px;
    }

    &--primary-dark {
      background: $primary-dark;
      color: $white;
    }

    &--primary {
      background: $primary;
      color: $white;
    }

    &--primary-light {
      background: $primary-light;
      color: $grey;
    }
  }
</style>